export const enum TruckingCompanyTypes {
  Insured = 0,
  Prospect = 1,
  MGA = 2,
  Carrier = 3,
  FinanceCompany = 4,
  ReferralSource = 5,
  Other = 6,
};
